define('legacy/referafriend/referafriend',['jquery'], function($) {
	'use strict';
	/**
	 * Toggle the tab elements for refer a friend
	 *
	 * @param tabElement
	 * @returns "false"
	 */
	window.toggleTab = function(tabElement) {
		window.setTab(tabElement);
		$('#tab-navigation > li > a:first-child').each(function(index, element) {
			if (tabElement === element) {
				$(element).attr('class', 'tab-active');
			} else {
				$(element).attr('class', 'tab-notactive');
			}
		});
		$('#one-column > div').each(function(index, element) {
			if ($(element).attr('id').split('-')[0] === $(tabElement).attr('id')) {
				$(element).css('display', 'block');
			} else {
				$(element).css('display', 'none');
			}
		});
		return false;
	};

	/**
	 * Set the tab element if it has been clicked before
	 */
	window.initTab = function() {
		window.tabElement = window.getTab();
		if (window.tabElement !== null) {
			$('#tab-navigation > li > a:first-child').each(function(index, element) {
				if (window.tabElement.attr('id') === $(element).attr('id')) {
					$(element).attr('class', 'tab-active');
				} else {
					$(element).attr('class', 'tab-notactive');
				}
			});
			$('#one-column > div').each(function(index, element) {
				if (window.tabElement.attr('id') === $(element).attr('id').split('-')[0]) {
					$(element).css('display', 'block');
				} else {
					$(element).css('display', 'none');
				}
			});
		}
	};

	/**
	 * Overload the clicked tab element
	 *
	 * @param tabElement
	 */
	window.setTab = function(tabElement) {
		window.parent.pushedTabElement = tabElement;
	};

	/**
	 * Get the overloaded tab variable
	 *
	 * @returns
	 */
	window.getTab = function() {
		if (window.parent.pushedTabElement !== null) {
			return $(window.parent.pushedTabElement);
		} else {
			return window.parent.pushedTabElement;
		}
	};

	/**
	 * Remove an item from the invite list
	 *
	 * @param aLink
	 */
	window.removeFromList = function(aLink) {
		var reference = $(aLink).parent().parent().find('p').html();
		$.ajax({
			url: window.getProp('URL'),
			async: true,
			data: 'flow=5003&reference=' + reference
		});
		$(aLink).parent().parent().remove();
	};

	/**
	 * Send a reminder to the invited user
	 *
	 * @param aLink
	 * @param header
	 */
	window.sendReminder = function(aLink, header) {
		var reference = $(aLink).parent().parent().find('p').html();
		$.ajax({
			url: window.getProp('URL'),
			async: true,
			data: 'flow=5002&reference=' + reference
		});
		var reminderSentPopup = document.getElementById('reminderSent');
		var breadText = $('#BREAD_REMINDER_SENT').html();
		breadText = breadText.replace('%s', reference);
		$('#BREAD_REMINDER_SENT').html(breadText);
		window.top.showModalPanel(header, reminderSentPopup.innerHTML, null, null, 'bodyframe', true, true);
	};

	/**
	 * Opens the invitation form for referring a friend
	 *
	 * @param formName
	 * @param header
	 */
	window.openInvitationForm = function(formName, header) {
		var invitationEmailForm = document.getElementById(formName);
		window.top.showModalPanel(header, invitationEmailForm.innerHTML, null, null, 'bodyframe', true, true, true);
	};

});

